import {Suspense, lazy} from 'react'
import Loader from "../customs/loader/main"


const Main = lazy(() => import("../components/settings/main"))

const Settings = () => {
  return (
    // <Layout>
    <Suspense fallback={<Loader />}> 
        <Main />
    </Suspense>
    // </Layout>
    
  )
}

export default Settings